<template>
  <div class="field relative flex w-full items-center text-neutral-900">
    <div class="leading absolute top-1/2 -translate-y-1/2">
      <CommonUIcons
        class="prefix-icon h-icon_size_3 w-icon_size_3"
        :name="prefix_icon"
      />

      <slot name="leading" />
    </div>

    <input
      v-model="value"
      class="field-input box-border w-full outline-none"
      :type
      :placeholder
      :disabled
      :name
      :inputmode
      :maxlength
      :aria-label="name"
      :class="{
        'icon-input-padding': prefix_icon || $slots.leading,
        'no-icon-input-padding': !prefix_icon && !$slots.leading,
        '!border-errors': error,
      }"
      @input="handleInput"
      @focus="$emit('focus', value)"
      @blur="$emit('blur', $event)"
      @change="$emit('change', value)"
    />

    <div class="suffix-icon absolute top-1/2 -translate-y-1/2">
      <CommonUIcons
        class="h-icon_size_3 w-icon_size_3 cursor-pointer"
        :name="suffix_icon"
        @click="$emit('suffixIconClick')"
      />

      <slot name="trailing" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TextFieldProps } from "~/types/schemas/common/Atom/field";

const emit = defineEmits<{
  blur: [event: Event];
  change: [value: string | number | undefined];
  "update:modelValue": [value: string | number | undefined];
  focus: [value: string | number | undefined];
  suffixIconClick: [];
}>();

const props = defineProps<TextFieldProps>();

const value = ref(props.modelValue);

// FIXME: use defineModel instead
watch(
  () => props.modelValue,
  (newValue) => {
    value.value = newValue;
  },
);

const handleInput = () => {
  if (props.inputmode === "numeric" || props.inputmode === "decimal") {
    const pattern = props.inputmode === "numeric" ? /\D/g : /[^\d.]/g;
    value.value = value.value?.toString().replace(pattern, "") ?? "";
  }
  emit("update:modelValue", value.value);
};
</script>

<style scoped>
@import url("~/assets/css/common/atom/field.css");
</style>
